import React, {useState, useEffect, useMemo, useRef} from 'react';
import {Bar} from 'react-chartjs-2';
import 'chartjs-plugin-dragdata';
import {CategoryScale, Chart, LinearScale, BarElement} from 'chart.js';
import '../CheckinGraph.css';
Chart.register(LinearScale, CategoryScale, BarElement);

/**
 * La vue du graphique
 * @param {*} props props
 * @return {JSX}
 */
export default function CheckinInfoGraphView(props) {
  const [shouldRedraw] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const dataRef = useRef(props.data);
  const checkinRef = useRef(props.nbHeures);

  useEffect(() => {
    dataRef.current = props.data;
    checkinRef.current = props.nbHeures;
  }, [props.data, props.nbHeures]);

  const buildDataSet = (data) => {
    const labels = data.map((c) => {
      if (c.label2 !== undefined) {
        let label = c.label2;
        const words = label.split(' ');
        const pop = words.pop();

        label = words.join(' ');
        const substrings = [];

        for (let i = 0; i < label.length; i += 18) {
          substrings.push(label.substr(i, 18));
        }

        substrings.push(pop);
        return substrings;
      } else {
        return ' ';
      }
    });

    const options = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            data: data.map((c) => c.value),
            fill: true,
            tension: 0.4,
            borderWidth: 0,
            borderColor: 'darkred',
            backgroundColor: data.map((c) => c.color),
            pointHitRadius: 200,
          },
        ],
      },
      options: {

        interaction: {
          mode: 'index',
          intersect: false,
          animation: {
            drag: false,
          },
        },
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'linear',
            min: 0,
            max: 10,
            display: true,
            title: {
              color: 'white',
              display: true,
              text: 'Tâches',
              font: {
                size: 20,
              },
            },
            ticks: {
              color: 'white',
              display: false,
              font: {
                size: 20,
              },
            },
          },
          y: {
            title: {
              display: false,
            },
            ticks: {
              display: true,
              align: 'center',
              color: 'white',
              font: {
                size: '14px',
              },
            },
          },
        },

        onHover: function(e) {
          const point = e.chart.getElementsAtEventForMode(
              e,
              'nearest',
              {intersect: true},
              false,
          );
          if (point.length) e.native.target.style.cursor = 'grab';
          else e.native.target.style.cursor = 'default';
        },

        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
          dragData: {
            round: 1,
            showTooltip: true,
            onDragStart: function(e, element) {
            },
            onDrag: function(e, datasetIndex, index, value) {
              e.target.style.cursor = 'grabbing';

              dataRef.current[index].value = value;
              if (dataRef.current[index].value <= 1) {
                dataRef.current[index].value = 1;
              }

              props.onHandleChange(dataRef.current, checkinRef.current);
            },
          },
        },
      },
    };
    return options;
  };

  const localOption = useMemo(() => buildDataSet(props.data, props.nbHeures), [props.data]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 200);
  }, []);

  return (
    <div style={{height: props.data.length * 100 === 0 ? 1 : props.data.length * 120 + 'px'}}>
      {isLoaded && (
        <Bar
          redraw={shouldRedraw}
          data={localOption.data}
          options={localOption.options}
          plugins={localOption.plugins} />
      )}
    </div>
  );
}
